// src/components/NavBar/NavBarComponent.tsx
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from '../Context/UserContext';
import { signOut } from 'aws-amplify/auth';
import DfuseLogo from '../../assets/dfuse-blue-logo-32x32.svg';
import styles from './NavBarComponent.module.css';

const FALLBACK_DOT =
  'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';

export default function NavBarComponent() {
  const navigate = useNavigate();
  const { isAuthenticated, refreshUser } = useUserContext();

  // keep user fresh
  useEffect(() => {
    void refreshUser();
  }, [refreshUser]);

  const logoSrc =
    typeof DfuseLogo === 'string' && DfuseLogo.length > 0 ? DfuseLogo : FALLBACK_DOT;

  const handleLogin = () => navigate('/login');
  const handleStart = () => navigate('/register');

  const handleLogout = async () => {
    try {
      await signOut();
      await refreshUser();
    } finally {
      navigate('/');
    }
  };

  return (
    <header className={`${styles.navbar} ${styles.sticky} ${styles.navbarLight}`}>

      {/* Left: Logo + brand */}
      <div
        className={styles.navLeft}
        onClick={() => navigate('/')}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && navigate('/')}
      >
        <img src={logoSrc} alt="Dfuse logo" className={styles.navLogo} />
        <span className={styles.navTitle}>dfuse</span>
      </div>

      {/* Right: CTAs */}
      <div className={styles.navRight}>
        {!isAuthenticated ? (
          <>
            <button className={styles.btnGhost} onClick={handleLogin}>
              Log in
            </button>
            <button className={styles.btnPrimary} onClick={handleStart}>
              Start for Free
            </button>
          </>
        ) : (
          <button className={styles.btnGhost} onClick={handleLogout}>
            Log out
          </button>
        )}
      </div>
    </header>
  );
}
